import React from "react";
import axios from "axios";
import Select from "react-select";
import DataGrids from "../../table/DataGrid";
import Leftnav from "../leftNav/Leftnav";
import Navbar from "../navbar";
import "../usermanager/usermanager.css";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import Alert from "../alert/alert";
import { DataGrid, GridToolbarExport } from "@mui/x-data-grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import TextField from "@mui/material/TextField";
import {
  URL_ALLEVENTS,
  URL_CREATEEVENTS,
  URL_DELETEEVENTS,
  URL_GETORGDATA,
  URL_UPDATEEVENT,
  URL_UPDATEEVENTS,
  URL_UPLOADIMAGE,
} from "../../api/constants";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import SearchableDropdown from "./SearchableDropdown";
import Loader from "../Loader";

function Brandmaster() {
  const [rowpos, setrowpos] = useState("");
  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [OrgMcode, setOrgMcode] = useState("");
  const [TicketType, setTicketType] = useState("");
  const [BookingStartDate, setBookingStartDate] = useState("");
  const [BookingEndTime, setBookingEndTime] = useState("");
  const [IsDraft, setIsDraft] = useState("");
  const [Status, setStatus] = useState("");
  const [VenueName, setVenueName] = useState("");
  const [VenueLandMark, setVenueLandMark] = useState("");
  const [VenueLattitude, setVenueLattitude] = useState("");
  const [VenueLongitude, setVenueLongitude] = useState("");
  const [VenueAddress, setVenueAddress] = useState("");
  const [VenueCity, setVenueCity] = useState("");
  const [VenueState, setVenueState] = useState("");
  const [VenueCountry, setVenueCountry] = useState("");
  const [VenueType, setVenueType] = useState("");
  const [isimage, setisimage] = useState(true);
  const [uploadimage, setuploadimage] = useState("");
  const [imgsize, setimgsize] = useState(" animatingTop");
  const [UpdatedAt, setUpdatedAt] = useState("");
  const [Summary, setSummary] = useState("");
  const [color, setcolor] = useState("green");
  const [alert, setalert] = useState(false);
  const [alertmsg, setalertmsg] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showpopup, setshowpopup] = useState(false);
  const [updatebtn, setupdatebtn] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [plusbtn, setplusbtn] = useState(false);
  const [plusbtnview, setplusbtnview] = useState("none");
  const [minusbtnview, setminusbtnview] = useState("block");
  const [image, setImage] = useState();
  const [selectedfile, setselectedfile] = useState(null);
  const [imagetype, setimagetype] = useState("");
  const [subtype, setsubtype] = useState("");
  const [bannerImage, setbannerImage] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [dropdown, setdropdown] = useState([]);
  const [search, setsearch] = useState("");
  const [searchval, setsearchval] = useState("search event");
  const [valueforsearch, setvalueforsearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  setTimeout(() => {
    setalert(false);
  }, 4000);

  const [options, setOptions] = useState([]);

  useEffect(() => {
    var config = {
      method: "get",
      url: URL_GETORGDATA,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        // console.log(response.data);
        setdropdown(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const Goevent = (item) => {
    console.log(item);
    window.location.href = `/dashboard/itemmaster/eventdetails/${item.id}`;
  };

  const columns = [
    // { field: 'id', headerName: 'ID' },
    // {
    //   field: "path",
    //   headerName: "BANNER ",
    //   sortable: false,
    //   width: 100,
    //   disableClickEventBubbling: true,
    //   renderCell: () => {
    //     return (
    //       <>
    //        <img height="70%" width="100%" src={image} onClick={setbannerImage(true)} />
    //       </>
    //     );
    //   }
    // },
    { field: "name", headerName: "Event Name", width: 150 },
    { field: "venueLandMark", headerName: "Venue LandMark", width: 100 },
    { field: "venueAddress", headerName: "Venue Address", width: 120 },
    { field: "venueType", headerName: "Venue Type", width: 150 },
    { field: "summary", headerName: "Summary", width: 150 },

    {
      field: "startDate",
      headerName: "Start Date",
      width: 120,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return params.row.exhibitionStartDate
          .split("T")[0]
          .split("-")
          .reverse()
          .join()
          .replace(",", "-")
          .replace(",", "-");
      },
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 120,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return params.row.exhibitionEndDate
          .split("T")[0]
          .split("-")
          .reverse()
          .join()
          .replace(",", "-")
          .replace(",", "-");
      },
    },
    {
      field: "Event Detail",
      headerName: "View Event",
      sortable: false,
      width: 130,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => Goevent(params)}
          >
            view Detail
          </Button>
        );
      },
    },
    {
      field: "Action",
      headerName: "Delete",
      sortable: false,
      width: 130,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => edit(params.row)}
            style={{ background: "red" }}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  // blank all input fields after updating successfully !
  const blank = () => {
    setName("");
    setDescription("");
    setStartDate("");
    setEndDate("");
    setOrgMcode("");
    setTicketType("");
    setBookingStartDate("");
    setBookingEndTime("");
    setIsDraft("");
    setStatus("");
    setVenueName("");
    setVenueLandMark("");
    setVenueLattitude("");
    setVenueLongitude("");
    setVenueAddress("");
    setVenueCity("");
    setVenueState("");
    setVenueCountry("");
    setVenueType("");
    setUpdatedAt("");
  };

  //refresh function
  const refresh = () => {
    var data = JSON.stringify({
      status: "ALL",
    });

    var config = {
      method: "post",
      url: URL_ALLEVENTS,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response);
        setTableData(response.data);
        setOptions(response.data);
      })
      .catch(function (error) {
        console.log("oops" + error);
      });
  };

  const jsonArray = tableData.map((item) => {
    return {
      id: item.rowpos,
      name: item.name,
    };
  });

  //delete user

  const deleteuser = (item) => {
    setshowpopup(false);
    var rowpos = item.rowpos;
    var data = JSON.stringify({
      ROWPOS: rowpos,
    });

    var config = {
      method: "post",
      url: URL_DELETEEVENTS,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data);

        setalert(true);
        setalertmsg(`✔ ${item.name}  has been added successfully !`);
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // edit function

  const edit = (item) => {
    setshowpopup(true);
    setIsDisabled(false);
    setrowpos(item.rowpos);
  };

  //update
  const update = (item) => {
    setshowpopup(false);
    console.log(item);
    setrowpos(item.rowpos);
    setupdatebtn(true);
    setplusbtn(true);
    // console.log(item.startDate.slice(0,10))

    setName(item.name);
    setSummary(item.summary);
    setDescription(item.description);
    setStartDate(item.startDate.slice(0, 10));
    setEndDate(item.endDate.slice(0, 10));
    setOrgMcode(item.orgMcode);
    setTicketType(item.ticketType);
    setBookingStartDate(item.bookingStartDate.slice(0, 10));
    setBookingEndTime(item.bookingEndTime.slice(0, 10));
    setIsDraft(item.isDraft);
    setStatus(item.status);
    setVenueName(item.venueName);
    setVenueLandMark(item.venueLandMark);
    setVenueLattitude(item.venueLattitude);
    setVenueLongitude(item.venueLongitude);
    setVenueAddress(item.venueAddress);
    setVenueCity(item.venueCity);
    setVenueState(item.venueState);
    setVenueCountry(item.venueCountry);
    setVenueType(item.venueType);
    setUpdatedAt(item.updatedAt);

    console.log(item.media_list.length);

    if (item.media_list.length == 0) {
      console.log("no image");
      setisimage(false);
    } else {
      setImage(item.media_list[0].path);
      console.log("image url " + item.media_list[0].path);
    }
  };

  const updateuser = () => {
    var data = JSON.stringify({
      Name: Name,
      Summary: Summary,
      Description: Description,
      StartDate: StartDate,
      EndDate: EndDate,
      OrgMcode: OrgMcode,
      TicketType: TicketType,
      BookingStartDate: BookingStartDate,
      BookingEndTime: BookingEndTime,
      IsDraft: IsDraft,
      Status: Status,
      VenueName: VenueName,
      VenueLandMark: VenueLandMark,
      VenueLattitude: VenueLattitude,
      VenueLongitude: VenueLongitude,
      VenueAddress: VenueAddress,
      VenueCity: VenueCity,
      VenueState: VenueState,
      VenueCountry: VenueCountry,
      VenueType: VenueType,
      UpdatedAt: UpdatedAt,
      Approved: "0",
      ROWPOS: rowpos,
    });

    var config = {
      method: "post",
      url: URL_UPDATEEVENT,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data.isSuccess);
        console.log(response.data);

        if (response.data.isSuccess === true) {
          setalert(true);
          setalertmsg(`✔ ${Name}  has been Updated successfully !`);
          // refresh();
          blank();
          handleminus();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  var user = Cookies.get("userType");
  var Orgmcode = Cookies.get("orgmcode");
  var Org = [];

  // get all users
  useEffect(() => {
    setIsLoading(true);
    var data = JSON.stringify({
      status: "ALL",
    });

    var config = {
      method: "post",
      url: URL_ALLEVENTS,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log(response.data.data);
        var mydata = response.data.data;

        if (user === "ORGANIZER") {
          for (var i = 0; i < mydata.length; i++) {
            if (mydata[i].orgMcode == Orgmcode) {
              Org.push(mydata[i]);
            }
          }
          console.log("org", Org);
          setTableData(Org);
          setIsLoading(false);
        } else {
          setTableData(response.data.data);
          setIsLoading(false);
        }
        // setTableData(response.data.data)
      })
      .catch(function (error) {
        console.log("oops" + error);
        setIsLoading(false);
      });

    // _________________
  }, []);

  const adduser = () => {
    console.log("adduser");

    console.log(
      Name,
      Description,
      StartDate,
      EndDate,
      OrgMcode,
      TicketType,
      BookingStartDate,
      BookingEndTime,
      IsDraft,
      Status,
      VenueName,
      VenueLandMark,
      VenueLattitude,
      VenueLongitude,
      VenueAddress,
      VenueType,
      UpdatedAt
    );

    if (Name == "") {
      setalert(true);
      setalertmsg("Name can not be blank !");
      setcolor("red");
    } else if (Summary == "") {
      setalert(true);
      setalertmsg("Summary can not be blank !");
      setcolor("red");
    } else if (Description == "") {
      setalert(true);
      setalertmsg("Description can not be blank !");
      setcolor("red");
    } else if (StartDate == "") {
      setalert(true);
      setalertmsg("StartDate No can not be blank !");
      setcolor("red");
    } else if (EndDate == "") {
      setalert(true);
      setalertmsg("EndDate can not be blank !");
      setcolor("red");
    } else if (StartDate > EndDate) {
      setalert(true);
      setalertmsg("StartDate must be greater than today !");
      console.log("greater than");
      setcolor("red");
    } else if (OrgMcode == "") {
      setalert(true);
      setalertmsg("OrgMcode can not be blank !");
      setcolor("red");
    } else if (TicketType == "") {
      setalert(true);
      setalertmsg("TicketType can not be blank !");
      setcolor("red");
    } else if (BookingStartDate == "") {
      setalert(true);
      setalertmsg("BookingStartDate can not be blank !");
      setcolor("red");
    } else if (BookingEndTime == "") {
      setalert(true);
      setalertmsg("BookingEndTime can not be blank !");
      setcolor("red");
    } else if (IsDraft == "") {
      setalert(true);
      setalertmsg("IsDraft can not be blank !");
      setcolor("red");
    } else if (Status == "") {
      setalert(true);
      setalertmsg("Status can not be blank !");
      setcolor("red");
    } else if (VenueName == "") {
      setalert(true);
      setalertmsg("VenueName can not be blank !");
      setcolor("red");
    } else if (VenueLandMark == "") {
      setalert(true);
      setalertmsg("VenueLandMark can not be blank !");
      setcolor("red");
    } else if (Status == "") {
      setalert(true);
      setalertmsg("Status can not be blank !");
      setcolor("red");
    } else if (VenueAddress == "") {
      setalert(true);
      setalertmsg("VenueAddress can not be blank !");
      setcolor("red");
    } else if (VenueType == "") {
      setalert(true);
      setalertmsg("VenueType can not be blank !");
      setcolor("red");
    } else if (UpdatedAt == "") {
      setalert(true);
      setalertmsg("UpdatedAt can not be blank !");
      setcolor("red");
    }

    var data = JSON.stringify({
      Name: Name,
      Summary: Summary,
      Description: Description,
      StartDate: StartDate,
      EndDate: EndDate,
      OrgMcode: OrgMcode,
      TicketType: TicketType,
      BookingStartDate: BookingStartDate,
      BookingEndTime: BookingEndTime,
      IsDraft: IsDraft,
      Status: Status,
      VenueName: VenueName,
      VenueLandMark: VenueLandMark,
      VenueLattitude: VenueLattitude,
      VenueLongitude: VenueLongitude,
      VenueAddress: VenueAddress,
      VenueCity: VenueCity,
      VenueState: VenueState,
      VenueCountry: VenueCountry,
      VenueType: VenueType,
      UpdatedAt: UpdatedAt,
    });

    var config = {
      method: "post",
      url: URL_CREATEEVENTS,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data.isSuccess);
        if (response.data.isSuccess === true) {
          handleminus();
          setalert(true);
          setalertmsg(`✔ ${Name}  has been added successfully !`);
        }

        // refresh()
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleplus = () => {
    setplusbtnview("block");
    setminusbtnview("none");
    setplusbtn(true);
    setisimage(false);
    setIsDisabled(true);
    setStatus("PENDING");
    setIsDraft("FALSE");
  };
  const handleminus = () => {
    setplusbtnview("none");
    setminusbtnview("block");
    setplusbtn(false);
    setStatus("PENDING");
  };

  const handleThisimage = () => {
    setimgsize("fullImage");
  };

  const onImageChange = (event) => {
    setselectedfile(event.target.files[0]);
    if (event.target.files || event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
      // setisimage(true)
    }
  };

  const imageupload = () => {
    console.log(selectedfile);
    console.log(imagetype);
    console.log(subtype);

    var FormData = require("form-data");
    var data = new FormData();
    data.append("File", selectedfile);
    data.append("Type", imagetype);
    data.append("Id", rowpos);
    data.append("SubType", subtype);

    var config = {
      method: "post",
      url: URL_UPLOADIMAGE,
      headers: {},
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response.data.isSuccess);
        if (response.data.isSuccess == true) {
          setalert(true);
          setalertmsg(` image upload successfully of item id ${rowpos} `);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const searchevent = () => {
    console.log(valueforsearch);

    if (valueforsearch === "") {
      setalert(true);
      setalertmsg("please Select Event to search ! ");
      return;
    } else {
      navigate(`/dashboard/itemmaster/eventdetails/${valueforsearch}`);
    }
  };

  //  --------------

  function handleSearchInputChange(inputValue) {
    // use filter method to create a new array of options that match the input value
    const filteredOptions = options.filter((option) =>
      option.name.toLowerCase().includes(inputValue.toLowerCase())
    );
    console.log(filteredOptions);
  }

  const transformedOptions = tableData.map((option) => ({
    id: option.rowpos,
    label: option.name,
  }));

  const handlesearchval = (val) => {
    setvalueforsearch(val);
  };

  const handleget = (val) => {
    console.log(val);
  };

  return (
    <>
      <Navbar />
      <Leftnav />

      {alert ? (
        <Alert className="top animatingTop" msg={alertmsg} color={color} />
      ) : (
        ""
      )}

      <div className="main">
        <center>
          <h5 className="pagenames orgrank animatingLeft">Manage Events</h5>
        </center>
        <br />
        {bannerImage ? (
          <>
            <div className="showbanner">
              <img style={{ height: "100%", width: "100%" }} src={image} />
            </div>
          </>
        ) : (
          ""
        )}

        {plusbtn ? (
          <div className="">
            <form className="d-flex space">
              <div className="mb-3 animatingBottom">
                <label className="form-label"> Name</label>
                <input
                  type="text"
                  value={Name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label">Description</label>
                <input
                  type="text"
                  value={Description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">
                  Start Date &nbsp;&nbsp;&nbsp;
                </label>

                <input
                  type="date"
                  value={StartDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="form-control small"
                />
              </div>
            </form>
            <div className="d-flex space">
              <div className="mb-3 animatingTop">
                <label className="form-label">
                  End Date &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </label>
                <input
                  type="date"
                  value={EndDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="form-control "
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">OrgMcode</label>
                <br />
                <select
                  className=" "
                  value={OrgMcode}
                  onChange={(e) => setOrgMcode(e.target.value)}
                >
                  <option></option>
                  {dropdown.map((option) => (
                    <option key={option.orgMcode} value={option.orgMcode}>
                      {option.orgName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3 animatingBottom">
                <label className="form-label">TICKET TYPE</label>
                <br />
                <select
                  className=" "
                  style={{ width: "230px" }}
                  value={TicketType}
                  onChange={(e) => setTicketType(e.target.value)}
                >
                  <option></option>
                  <option value="TICKET">TICKET</option>
                  <option value="BOOTH">BOOTH</option>
                </select>
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingBottom">
                <label className="form-label">Booking Start Date</label>
                <input
                  type="date"
                  value={BookingStartDate}
                  onChange={(e) => setBookingStartDate(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label">Booking End Time</label>
                <input
                  type="date"
                  value={BookingEndTime}
                  onChange={(e) => setBookingEndTime(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">IsDraft</label>
                <input
                  type="text"
                  value={IsDraft}
                  onChange={(e) => setIsDraft(e.target.value)}
                  className="form-control small"
                  disabled={isDisabled}
                />
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingTop">
                <label className="form-label">Status</label>
                <input
                  type="text"
                  value={Status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="form-control small"
                  disabled={isDisabled}
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">VenueName</label>
                <input
                  type="text"
                  value={VenueName}
                  onChange={(e) => setVenueName(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label">VenueLandMark</label>
                <input
                  type="text"
                  value={VenueLandMark}
                  onChange={(e) => setVenueLandMark(e.target.value)}
                  className="form-control small"
                />
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingBottom">
                <label className="form-label">Venue Lattitude</label>
                <input
                  type="text"
                  value={VenueLattitude}
                  onChange={(e) => setVenueLattitude(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label">Venue Longitude</label>
                <input
                  type="text"
                  value={VenueLongitude}
                  onChange={(e) => setVenueLongitude(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">VenueAddress</label>
                <input
                  type="text"
                  value={VenueAddress}
                  onChange={(e) => setVenueAddress(e.target.value)}
                  className="form-control small"
                />
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingTop">
                <label className="form-label">VenueCity</label>
                <input
                  type="text"
                  value={VenueCity}
                  onChange={(e) => setVenueCity(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">Venue State</label>
                <input
                  type="text"
                  value={VenueState}
                  onChange={(e) => setVenueState(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label">Venue Country</label>
                <input
                  type="text"
                  value={VenueCountry}
                  onChange={(e) => setVenueCountry(e.target.value)}
                  className="form-control small"
                />
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingBottom">
                <label className="form-label">Venue Type</label>
                <input
                  type="text"
                  value={VenueType}
                  onChange={(e) => setVenueType(e.target.value)}
                  className="form-control small"
                />
              </div>
              <div className="mb-3 animatingTop">
                <label className="form-label ">Banner Image</label>
                {isimage ? (
                  <div
                    className="imageview animatingBottom"
                    onClick={handleThisimage}
                    onDoubleClick={(e) => setimgsize("")}
                  >
                    <img src={image} className={imgsize} />
                  </div>
                ) : (
                  <>
                    <input
                      type="file"
                      onChange={onImageChange}
                      className="filetype form-control small animatingTop"
                      id="group_image"
                    />

                    <input
                      type="text"
                      value={imagetype}
                      placeholder="Image,GIF,Vedio"
                      onChange={(e) => setimagetype(e.target.value)}
                      className="form-control small"
                    />

                    <input
                      type="text"
                      value={subtype}
                      placeholder="Party,birthday,audition"
                      onChange={(e) => setsubtype(e.target.value)}
                      className="form-control small"
                    />
                    <br />

                    <Button
                      style={{ color: "#fff", background: "rgb(1, 94, 208)" }}
                      onClick={imageupload}
                    >
                      {" "}
                      Upload Image
                    </Button>
                  </>
                )}
              </div>
              <div className="mb-3 animatingBottom">
                <label className="form-label">Updated At</label>
                <input
                  type="date"
                  value={UpdatedAt}
                  onChange={(e) => setUpdatedAt(e.target.value)}
                  className="form-control small"
                />
              </div>
            </div>
            <div className="d-flex space">
              <div className="mb-3 animatingBottom">
                <label className="form-label">Summary</label>
                <input
                  type="text"
                  value={Summary}
                  onChange={(e) => setSummary(e.target.value)}
                  className="form-control small"
                />
              </div>
            </div>

            <div className="mb-3 mtop animatingBottom">
              <Button
                style={{ marginLeft: "40px" }}
                variant="contained"
                onClick={adduser}
              >
                Add Event
              </Button>
              {updatebtn ? (
                <Button
                  style={{ marginLeft: "40px" }}
                  variant="contained"
                  onClick={updateuser}
                >
                  Update Event
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="eventsearchflex">
          <div className="toggle animatingTop">
            {/* <button className={minusbtnview} id="plusadduser" onClick={handleplus}><ion-icon name="add-outline"></ion-icon></button> */}
            <button className={plusbtnview} onClick={handleminus}>
              <ion-icon name="arrow-up-outline"></ion-icon>
            </button>
          </div>

          <div
            className="mb-3 animatingBottom"
            style={{ width: "200px", marginLeft: "105px" }}
          >
            <div
              className="searchbtn"
              style={{ display: "flex", zIndex: "1000" }}
            >
              {/* <select value={search}
         onKeyPress={(e) => e.key === 'Enter' && searchevent()}
         placeholder="Search event"
         onChange={(e) => setsearch(e.target.value)}>
          <option>search Event</option>
          {
    tableData?.map((items,index)=>(
    
        <option key={index} value={items.rowpos} >{items.name}</option>
    
    ))
  }
         </select> */}

              {/* --------2nd  */}

              <SearchableDropdown
                options={jsonArray}
                label="name"
                id="rowpos"
                selectedVal={searchval}
                handleChange={(val) => setsearchval(val)}
                handleChangeval={(val) => handlesearchval(val)}
                onKeyPress={(val) => handleget(val)}
              />

              {/* ---------- */}
              {/* <Select
  options={transformedOptions }
  isSearchable={true}
  placeholder="Search event"
  onKeyPress={(e) => e.key === 'Enter' && searchevent()}
  // onInputChange={handleSearchInputChange}
/> */}

              <img
                height="24px"
                onClick={searchevent}
                style={{
                  borderRadius: "50%",
                  marginTop: "12px",
                  marginLeft: "5px",
                }}
                src="data:image/jpeg;base64,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"
              />
            </div>
          </div>
        </div>

        {isLoading ? (
          <Loader />
        ) : (
          <div
            className="item-master-tbl animatingBottom dashtbl"
            // style={{ marginTop: "20px", overflow: "hidden", width: "83%" }}
          >
            <DataGrid
              rows={tableData}
              columns={columns}
              getRowId={(row) => row.rowpos}
              pageSize={6}
              components={{
                Toolbar: GridToolbarExport,
              }}
              // checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = tableData.filter((row) =>
                  selectedIDs.has(row.rowpos)
                );

                setSelectedRows(selectedRows);
                console.log(selectedRows);
                // setfirstname(selectedRows.mcode)
              }}
              {...tableData}
            />
            {showpopup ? (
              <div>
                <div className="userpopup animatingTop">
                  <p className="cross mb" onClick={() => setshowpopup(false)}>
                    <ion-icon name="close-outline"></ion-icon>
                  </p>
                  {tableData.map(
                    (item) =>
                      item.rowpos === rowpos && (
                        <>
                          <div className="popupdata animatingBottom">
                            <p>
                              Are You sure to delete <br />
                              <br />
                              <span>{item.name}</span> Event
                            </p>
                          </div>

                          <Button
                            variant="contained"
                            onClick={() => deleteuser(item)}
                          >
                            delete
                          </Button>
                        </>
                      )
                  )}
                </div>
              </div>
            ) : (
              " "
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default Brandmaster;
